import type { DetailsCarPart } from '@autobid/ui/types/components/CarDetails'

export type PartName = 'exterior' | 'interior' | 'windshield'

export function useDetailsPart(partName: PartName, part?: DetailsCarPart) {
  const { t } = useI18n()
  const PART_LABELS = {
    exterior: {
      title: t('car-details.section.images-exterior'),
      photos: t('car-details.more-body-photos'),
      list: t('car-details.other-body-damage'),
    },
    interior: {
      title: t('car-details.section.images-interior'),
      photos: t('car-details.more-interior-photos'),
      list: t('car-details.other-interior-damage'),
    },
    windshield: {
      title: t('car-details.section.images-windscreen'),
      photos: t('car-details.more-windshield-photos'),
      list: t('car-details.other-windshield-damage'),
    },
  }

  const shouldBeRendered = (function () {
    const { list, table, images } = part ?? {}

    return (
      list?.[0]?.length
      || list?.[1]?.length
      || table?.tableCells?.length
      || images?.length
    )
  })()

  const list = part?.list?.[0]?.join(', ') ?? ''

  const freeText = part?.list?.[1]

  const labels = PART_LABELS[partName]

  return { shouldBeRendered, list, freeText, labels }
}
